const StoreIcon = () => {
  return (
    <svg fill="none" height="55" viewBox="0 0 46 46" width="50" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 13H36V36H6V13Z" fill="white" stroke="#00AEEF" strokeWidth="2" />
      <path d="M6 14H21V19H6V14Z" fill="#00AEEF" fillOpacity="0.2" />
      <path d="M7 19H8V24H7V19Z" fill="#00AEEF" fillOpacity="0.2" />
      <path d="M6 24H21V35H6V24Z" fill="#00AEEF" fillOpacity="0.2" />
      <path d="M2.60796 7H38.392L39.7487 13H1.25135L2.60796 7Z" fill="white" stroke="#00AEEF" strokeWidth="2" />
      <path d="M23 19H32L32 36H23L23 19Z" stroke="#00AEEF" strokeWidth="2" />
      <path d="M9 19H20V25H9L9 19Z" fill="white" stroke="#00AEEF" strokeWidth="2" />
      <path d="M6 1H36V6.5H6V1Z" fill="white" stroke="#00AEEF" strokeWidth="2" />
      <path d="M6 2H21V6H6V2Z" fill="#00AEEF" fillOpacity="0.2" />
    </svg>
  );
};
export default StoreIcon;
